import React from 'react';

/* The anti-overfitting device. 3px --loss rule directly beneath the title, count
   in --num-lg. NOT DISMISSABLE, and present on every export and every screenshot
   of the view. A fleet is also a search. */

export function CautionBand({ count, unit = 'configurations tried', message = 'This is a search result, not a finding.', style }) {
  return (
    <div role="note" style={{
      display: 'flex', alignItems: 'baseline', gap: 'var(--space-12)', flexWrap: 'wrap',
      borderLeft: '3px solid var(--loss)', background: 'var(--bg-surface)',
      padding: 'var(--space-12) var(--space-16)', ...style,
    }}>
      <span style={{
        fontSize: 'var(--num-lg-size)', lineHeight: 'var(--num-lg-line)', fontWeight: 'var(--num-lg-weight)',
        fontVariantNumeric: 'tabular-nums slashed-zero', color: 'var(--text-primary)',
      }}>{count}</span>
      <span style={{ fontSize: 'var(--body-size)', lineHeight: 'var(--body-line)', color: 'var(--text-secondary)' }}>
        {unit}. <span style={{ color: 'var(--text-primary)' }}>{message}</span>
      </span>
    </div>
  );
}
